export default "__VITE_ASSET__rWnzXk2X__"